(async function () {
  const giftCodeInput = document.getElementById('gift-code-input');
  const checkExpirationBtn = document.getElementById('check-expiration-btn');
  const messageArea = document.getElementById('message-area');
  const formatNumberWithCommas = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const updateMessage = (text, isRedText = false) => {
    messageArea.style.display = 'block';
    messageArea.querySelector('p').innerText = text;
    if (isRedText) {
      messageArea.style.color = '#e74c3c';
    } else {
      messageArea.style.color = '#1A1B18';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
    const dayOfWeek = daysOfWeek[date.getDay()];
    return `${year}年${month}月${day}日 (${dayOfWeek})`;
  };

  const addSpaces = (value) => value.replace(/(.{4})/g, '$1 ').trim();
  const removeSpaces = (value) => value.replace(/\s+/g, '');

  giftCodeInput.addEventListener('input', (event) => {
    const processedValue = removeSpaces(event.target.value).slice(0, 16);
    event.target.value = processedValue.length === 16 ? addSpaces(processedValue) : processedValue;
    event.target.style.backgroundColor = '#FAFFBD';

    if (removeSpaces(event.target.value).length > 16) {
      checkExpirationBtn.disabled = true;
      checkExpirationBtn.classList.remove('active-btn');
      messageArea.style.display = 'block';
    } else if (!/^[a-zA-Z0-9]*$/.test(removeSpaces(event.target.value))) {
      updateMessage('使用できない文字が含まれています。', true);
      checkExpirationBtn.disabled = true;
      checkExpirationBtn.classList.remove('active-btn');
      messageArea.style.display = 'block';
    } else if (removeSpaces(event.target.value).trim() === '') {
      checkExpirationBtn.disabled = true;
      checkExpirationBtn.classList.remove('active-btn');
      messageArea.style.display = 'none';
      event.target.style.backgroundColor = '#FFFFFF';
    } else if (removeSpaces(event.target.value).length === 16) {
      checkExpirationBtn.disabled = false;
      checkExpirationBtn.classList.add('active-btn');
      messageArea.style.display = 'none';
    } else {
      checkExpirationBtn.disabled = true;
      checkExpirationBtn.classList.remove('active-btn');
      messageArea.style.display = 'none';
    }
  });

  checkExpirationBtn.addEventListener('click', async function (event) {
    event.target.disabled = true;
    const url = '/apps/kuradashi-app-proxy/gift-cards/' + removeSpaces(giftCodeInput.value);
    let response;
    try {
      response = await fetch(url);
    } catch (error) {
      updateMessage('ネットワークエラーが発生しました。\nしばらくしてからもう一度お試しください。', true);
      event.target.disabled = false;
      return;
    }
    if (!response.ok) {
      updateMessage('サーバエラーが発生しました。\nしばらくしてからもう一度お試しください。', true);
      event.target.disabled = false;
      return;
    }
    const data = await response.json();
    if ('expiresOn' in data) {
      if (data.expiresOn === null) {
        updateMessage(`有効期限 : ありません。\n残数 : ${formatNumberWithCommas(Number(data.balance))}円分`);
      } else {
        updateMessage(
          `有効期限 : ${formatDate(data.expiresOn)}\n残数 : ${formatNumberWithCommas(Number(data.balance))}円分`,
        );
      }
    } else {
      updateMessage('ギフトカードが無効です。\nもう一度お試しください。', true);
    }
    event.target.disabled = false;
  });
})();
